import React, { useState, useEffect } from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// @material-ui/icons
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
// core components
import Header from "components/Header/Header.js";
import Footer from "components/Footer/Footer.js";
import Button from '@material-ui/core/Button';
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import HeaderLinks from "components/Header/HeaderLinks.js";
import Parallax from "components/Parallax/Parallax.js";
import { Helmet } from 'react-helmet'



import styles from "assets/jss/material-kit-react/views/spaghetti.js";
import { string } from "prop-types";

const useStyles = makeStyles(styles);

export default function RoboCupSoccerSimulationMainPage(props) {
    const classes = useStyles();

    const { ...rest } = props;
    const imageClasses = classNames(
        classes.imgRaised,
        classes.imgRoundedCircle,
        classes.imgFluid
    );

    return (
        <div>
            <Header
                color="transparent"
                brand="Material Kit React"
                rightLinks={<HeaderLinks />}
                fixed
                changeColorOnScroll={{
                    height: 200,
                    color: "white"
                }}
                {...rest}
            />
            <Helmet>
                <title>کمپ آموزشی شریف | مسابقه شبیه سازی رایانه ای فوتبال</title>
                <meta name="description" content="شبیه سازی رایانه ای فوتبال دو بعدی، با موتور تحت ویندوز و زبان سی شارپ" />
                <meta name="" content="Robo-cup-soccer-simulation-windows, soccer simulation,robocup,شبیه سازی فوتبال، csharp, c#,سی شارپ، Events,Mobile,Programming,TopDev,Scrum,Agile,Course,Exhabitions,کمپ آموزشی, بوت کمپ" />
            </Helmet>
            <Parallax small filter image={require("assets/img/bg19.jpg")} />
            <div className={classNames(classes.main, classes.mainRaised)}>
                <div>
                    <div className={classes.container}>

                        <GridContainer justify="center" className={classes.box}>
                            <GridItem xs={12} sm={12} md={12}>
                                <div className={classes.topdev}>
                                    <div>
                                        <img src={"https://sharifcamp.ir/assets/images/robocup.jpg"} alt="..." className={imageClasses} />
                                    </div>
                                    <div className={classes.name}>
                                        <h3 className={classes.title}>مسابقه شبیه سازی رایانه ای فوتبال با سی شارپ</h3>
                                        <div className={classes.description}>
                                            <p>
                                                شبیه‌سازی فوتبال در دنیای کامپیوتر یک پروژه جذاب در حوزه هوش مصنوعی و برنامه‌نویسی است که به‌طور مشترک توسط گروه برنامه‌نویسان توسعه یافته است. این پروژه با هدف ارتقاء تجربه برنامه‌نویسی و تبادل ایده‌ها در جامعه برنامه‌نویسان به‌صورت ماهیانه برگزار می‌شود.
                                            </p>
                                        </div>
                                        <div>
                                            <p>
                                                <br />
                                                <Button variant="outlined" href="/ContactUs" disableElevation>
                                                    جهت دریافت راهنمایی و مشاوره، با متخصصان ما تماس بگیرید.
                                                </Button>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </GridItem>
                        </GridContainer>
                        <GridContainer className={classes.box}>
                            <GridItem xs={12} sm={12} md={12}>
                                <h4>هدف اصلی پروژه</h4>
                            </GridItem>
                            <GridItem xs={12} sm={12} md={12}>
                                <div className={classes.description}>
                                    <p>
                                        هدف اصلی این پروژه، ایجاد یک شبیه‌سازی فوتبال در محیط کامپیوتری است که برنامه‌نویسان قادر باشند با استفاده از الگوریتم‌های هوش مصنوعی، تاکتیک‌های بازیکنان و استراتژی تیم‌ها را تعریف کرده و در مسابقات مجازی به یکدیگر رقابت کنند.
                                    </p>
                                </div>
                            </GridItem>
                        </GridContainer>

                        <GridContainer className={classes.box}>
                            <GridItem xs={12} sm={12} md={12}>
                                <h4>ساختار پروژه</h4>
                            </GridItem>
                            <GridItem xs={12} sm={12} md={12}>
                                <div className={classes.description}>
                                    <p>
                                        این پروژه از دو شیء اصلی به نام‌های "تیم آبی" و "تیم سرخ" تشکیل شده است. هر برنامه‌نویس مسئول توسعه کدهای یکی از این تیم‌ها می‌باشد. کدهای نوشته شده در زمان اجرا به‌صورت همزمان با یکدیگر تعامل می‌کنند و بازی فوتبال مجازی را برگزار می‌کنند.
                                    </p>
                                    <p>
                                    برنامه‌نویسان می‌توانند با داشتن دانش مقدماتی در زبان C#، به راحتی در این مسابقات شرکت کنند. آشنایی با مفاهیم ابتدایی مانند متغیرها، شرط‌ها، حلقه‌ها و توابع کافی است. همچنین، امکان استفاده از دستورات ساده مانند شوت، پاس و حرکت به برنامه‌نویسان ارائه شده است تا تاکتیک‌های مختلف را به راحتی پیاده‌سازی کرده و در مسابقات شرکت کنند.
                                    </p>
                                    
                                </div>
                            </GridItem>
                        </GridContainer>
                        <GridContainer className={classes.box}>
                            <GridItem xs={12} sm={12} md={12}>
                                <h4>ویژگی‌ها</h4>
                            </GridItem>
                            <GridItem xs={12} sm={12} md={12}>
                                <div className={classes.description}>
                                    <p>
                                        <ul>
                                            <li>
                                                دستورات ساده مانند شوت، پاس و حرکت قابل تعریف توسط برنامه‌نویسان.
                                            </li>
                                            <li>
                                                امکان مشاهده جایگاه بازیکنان، وضعیت توپ و سایر اطلاعات مرتبط.
                                            </li>
                                            <li>
                                                سیستم چندنخی با صف دستورات جهت اجرای یک به یک استراتژی تیم‌ها.
                                            </li>
                                        </ul>
                                    </p>
                                    <p>
                                    مسابقات شبیه‌سازی فوتبال برنامه‌نویسان یک چالش گسترده و چندلایه است که برای برنامه‌نویسان از سطوح مختلف تحصیلی ارائه شده است. این مسابقات امکان شرکت و رقابت برنامه‌نویسان با تمام سطوح از دانش آموز تا دانشجو و استاد را با هدف افزایش دانش و توانمندی در زمینه برنامه‌نویسی فراهم می‌کند و میتواند در کنار آموزش، لحظات مفرحی را نیز ایجاد کند.
                                    </p>
                                </div>
                            </GridItem>
                        </GridContainer>
                        <GridContainer className={classes.box}>
                            <GridItem xs={12} sm={12} md={12}>
                                <h4>تاریخچه</h4>
                            </GridItem>
                            <GridItem xs={12} sm={12} md={12}>
                                <div className={classes.description}>
                                    <p>
                                    تاکنون این موتور با نسخه‌های مختلف خود، میزبان مسابقات متعددی در داخل کشور بوده است. این مسابقات به عنوان یک فرصت عالی برای ارتقاء و بهبود برنامه نویسی و همچنین تبادل تجربیات بین توسعه‌دهندگان و تفریح جذاب آنها بوده است..
                                    </p>
                                    <p>
                                        <ul>
                                            <li>
                                                <strong>
                                            نسخه 1.0 و 1.1 - C++
                                            </strong>
                                            <br/>
                                            دوره‌های اولیه این مسابقات با نسخه‌های 1.0 و 1.1 این موتور در سطح دانشگاه با استفاده از زبان C++ برگزار شدند. این دوره‌ها به‌عنوان یک فاز تستی به منظور بررسی کارایی سیستم انتخاب شدند.
                                            </li>
                                            <li>
                                                <strong>
                                                نسخه 2.3 - C#
                                            </strong>
                                            <br/>
                                            با پیشرفت و توسعه موتور به نسخه 2.3، با حضور 21 تیم از 17 دانشگاه مختلف اولین دوره مسابقات کشوری به میزبانی دانشگاه علوم و فنون مازندران برگزار شد.
                                            <br />
                                            دومین دوره مسابقات کشوری نیز به میزبانی دانشگاه زنجان برگزار شد. که انگیزه و تعهد توسعه‌دهندگان را برای بهبود موتور بیشتر کرد.
                                            </li>
                                            <li>
                                                <strong>
                                                نسخه 4.7 - C#
                                            </strong>
                                            <br/>
                                            سومین دوره این مسابقه به صورت ملی همزمان با مسابقه سایر رشته های روباتیک به میزبانی دانشگاه علوم و فنون مازندران برگزار شد یکی از جذاب‌ترین رویدادهای رباتیک شمال کشور بود و با حضور تیم‌های مختلف، بسیار رقابتی، چالشی و هیجان انگیز بود.
                                             </li>
                                        </ul>
                                    </p>
                                </div>
                            </GridItem>
                        </GridContainer>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
}
